export default __webpack_public_path__ + "static/media/Nearshoring_.c351c47a.png";